import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl } from 'react-intl'

import Error from './form-input-error'

import Label from '../label'

class InputText extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.array
        ]),
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        waitInMs: PropTypes.number
    }
    static defaultProps = {
        waitInMs: 500,
        value: '',
        disabled: false
    }

    onChangeTimeout = false;

    state = {}


    handleChange(event) {
        let { value } = event.target
        this.setState({value})

        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
        this.onChangeTimeout = setTimeout(() => this.onChange(value), this.props.waitInMs)
    }

    onChange(value) {
        // if(value === this.state.value) return

        const { onChange = false } = this.props
        if(!onChange) {
            return
        }
        const promise = onChange(value);
        if(!promise || !promise.then) {
            return
        }
        !promise._state && this.setState({loading: true})
        promise.then(e => this.setState({loading: false, error: false}))
            .catch( e => this.setState({loading: false, error: true}));
    }


    onClick(event) {
        this.handleChange(event)
    }

    onBlur(event) {
        this.handleChange(event)
    }

    componentDidMount() {
        // this.refs.inputText.focus();
    }

    componentWillUnmount() {
        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({value: nextProps.value})
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        return nextProps.value && nextProps.value !== this.state.value
    }

    render() {
        const {intl, label=false, className=false, disabled} = this.props;
        const {value=this.props.value, error=false, loading=false } = this.state;

        return <div className={"form form-text" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>

            <div className={'form-data' + (error?' error':'')}>
                {(disabled || loading) ? <div className="disabled">{value}</div> :
                    <input type="text"
                        ref="inputText"
                        placeholder={label ? intl.formatMessage({id: label + '.placeholder'}) : ''}
                        onChange={this.handleChange.bind(this)}
                        onClick={this.onClick.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        value={value} />}
                <Error visible={error} message={label ? label + '.errorStr' : 'app.error'} />
            </div>
        </div>
    }
}

export default injectIntl(InputText)

